import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get attendance
export const getAttendance = createAsyncThunk(
  "attendance/getAttendance",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (params.from_date) queryParams.append("from_date", params.from_date);
      if (params.to_date) queryParams.append("to_date", params.to_date);

      const url = `${BASE_URL}/attendance${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get attendance!";
      return rejectWithValue(message);
    }
  },
);

// Get attendance reports
export const getAttendanceReports = createAsyncThunk(
  "attendance/getAttendanceReports",
  async (params, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) {
        throw new Error("No authentication token found");
      }
      const queryParams = new URLSearchParams();
      queryParams.append("year", params.year);
      queryParams.append("month", params.month);
      const url = `${BASE_URL}/hr-reports/attendance?${queryParams.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get attendance reports!";
      return rejectWithValue(message);
    }
  },
);

// Check in
export const checkIn = createAsyncThunk(
  "attendance/checkIn",
  async (checkInData, { rejectWithValue }) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const dataToSend = {
        employee_id: checkInData.employee_id,
        notes: checkInData.check_in_notes || "",
      };

      const currentLang = getCurrentLanguage();
      const response = await axios.post(
        `${BASE_URL}/attendance/check-in`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to check in!";
      return rejectWithValue(message);
    }
  },
);

// Check out
export const checkOut = createAsyncThunk(
  "attendance/checkOut",
  async (checkOutData, { rejectWithValue }) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const dataToSend = {
        employee_id: checkOutData.employee_id,
        notes: checkOutData.check_out_notes || "",
      };

      const currentLang = getCurrentLanguage();
      const response = await axios.post(
        `${BASE_URL}/attendance/check-out`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to check out!";
      return rejectWithValue(message);
    }
  },
);
